import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { formatCash } from "config/constant";

const TableLoyalty = props => {
	const { loyaltyProductMappings } = props;
	const classes = useStyles();

	return (
		loyaltyProductMappings?.length > 0 && (
			<Grid classes={{ root: classes.root }}>
				<Grid classes={{ root: classes.header }}>
					<Grid container spacing={1}>
						<Grid item xs={4}>
							Áp dụng
							<br /> phân khúc,
							<br /> nhóm SP
						</Grid>
						<Grid
							item
							xs={4}
							classes={{ root: classes.headerCenter }}
						>
							Không
							<br /> áp dụng
							<br /> nhóm SP
						</Grid>
						<Grid item xs={4} classes={{ root: classes.headerEnd }}>
							Doanh số
							<br /> qui đổi
							<br /> 1 điểm
						</Grid>
					</Grid>
				</Grid>
				<Grid classes={{ root: classes.content }}>
					{loyaltyProductMappings?.map((product, index) => (
						<Grid
							container
							key={index}
							alignItems="center"
							style={{
								padding: "5px 10px",
								background: index % 2 !== 0 ? "#F4F6FA" : ""
							}}
						>
							<Grid item xs={4}>
								{product?.productSegmentName ||
									product?.productGroupName}
							</Grid>
							<Grid item xs={4} style={{ paddingLeft: 3 }}>
								{product?.exceptedProductGroupName}
							</Grid>
							<Grid item xs={4} style={{ textAlign: "end" }}>
								{formatCash(product?.amount || 0)} Đ
							</Grid>
						</Grid>
					))}
				</Grid>
			</Grid>
		)
	);
};

export default memo(TableLoyalty);
